import React from 'react';
import styled, { css } from 'styled-components';

import { blueColor, lightGrey2Color, lightGrey1Color } from 'js/config/style';
import { buttonHeight, lineHeight, verticalPadding, horizontalPadding } from 'js/components/common/Button';
export { buttonHeight, lineHeight, verticalPadding, horizontalPadding };

import AnimatedBox from './AnimatedBox';

const SVGIcon = styled(({ side, ...rest }) => <img {...rest} />)`
  margin-right: 1rem;
  position: relative;
  top: -1px;
  width: 1rem;
`;

const solidBackground = css`
  background: white;
`;

const animatedBackground = css`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${({ color }) => {
    color = lightGrey1Color;
    return `linear-gradient(to right, ${color.brighten(1).hex()} 8%, ${color.hex()} 18%, ${color
      .brighten(1)
      .hex()} 33%)`;
  }};
  background-size: 1000px 104px;
`;

const Button = styled(({ isLoading, ...rest }) => <button {...rest} />)`
  display: block;
  position: relative;
  width: 100%;
  color: ${blueColor};
  box-shadow: none;
  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.3);
  line-height: ${lineHeight}rem;
  padding: ${verticalPadding}rem ${horizontalPadding}rem;
  border-radius: 0.25rem;
  border: 1px solid ${lightGrey2Color};
  cursor: pointer;
  ${({ isLoading }) => (isLoading ? animatedBackground : solidBackground)};

  &:active {
    box-shadow: none;
  }
`;

export default ({ config, from, noIcon, to, children, icon, ...rest }) => (
  <AnimatedBox from={from} to={to} config={config}>
    <Button {...rest}>
      {!noIcon && <SVGIcon src={icon || '/images/blue_plus.svg'} />}
      {children}
    </Button>
  </AnimatedBox>
);
